import {ParameterGroup} from '../Parameters.types'

import type {Property} from 'src/services/rest'
import {objectEntries} from 'src/utils/object'

export function groupParameters(parameters: readonly Property[]) {
  return objectEntries(
    parameters.reduce<Record<ParameterGroup, Property[]>>(
      (acc, property) => {
        const name = property?.name

        if (name == null) {
          acc[ParameterGroup.CONFIGURATION].push(property)

          return acc
        }

        if (name.startsWith('system.')) {
          acc[ParameterGroup.SYSTEM].push(property)
        } else if (name.startsWith('env.')) {
          acc[ParameterGroup.ENVIRONMENT].push(property)
        } else if (name.startsWith('dep.')) {
          acc[ParameterGroup.DEPENDENCIES].push(property)
        } else {
          acc[ParameterGroup.CONFIGURATION].push(property)
        }
        return acc
      },
      {
        [ParameterGroup.CONFIGURATION]: [],
        [ParameterGroup.SYSTEM]: [],
        [ParameterGroup.ENVIRONMENT]: [],
        [ParameterGroup.DEPENDENCIES]: [],
      },
    ),
  ).map(([group, items]) => ({
    group,
    items,
  }))
}
